import { css, cx } from 'linaria';
export const horizontalAnimation = `
  @keyframes tooltipFadeawayHorizontal {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    9%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
export const tooltipStyles = "t1221eea";
export const placementBottom = "pzhe358";
export const placementTop = "pmdugmx";
export const placementRight = "p1ihjjkq";
export const placementLeft = "pdweyzn";
export const delayStyle = "d1mp5exd";
export const bottomTooltip = cx(tooltipStyles, placementBottom);
export const bottomTooltipDelayed = cx(tooltipStyles, placementBottom, delayStyle);
export const topTooltip = cx(tooltipStyles, placementTop);
export const topTooltipDelayed = cx(tooltipStyles, placementTop, delayStyle);
export const rightTooltip = cx(tooltipStyles, placementRight);
export const rightTooltipDelayed = cx(tooltipStyles, placementRight, delayStyle);
export const leftTooltip = cx(tooltipStyles, placementLeft);
export const leftTooltipDelayed = cx(tooltipStyles, placementLeft, delayStyle);

require("./tooltip.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tooltip.js");